export const SET_BILL = "@BILLING_AND_INVOICING/SE_BILL";
export const SET_INVOICE = "@BILLING_AND_INVOICING/SET_INVOICE";
export const SET_INVOICE_SETTINGS = "@BILLING_AND_INVOICING/SET_INVOICE_SETTINGS";
export const SET_BILL_SETTING_LIST = "@BILLING_AND_INVOICING/SET_BILL_SETTING_LIST";
export const SET_BILL_SETTING_ITEM = "@BILLING_AND_INVOICING/SET_BILL_SETTING_ITEM";
export const SET_INVOICE_RECIPIENT = "@BILLING_AND_INVOICING/SET_INVOICE_RECIPIENT";
export const SET_INVOICE_RECIPIENT_LIST = "@BILLING_AND_INVOICING/SET_INVOICE_RECIPIENT_LIST";

export const SET_INVOICE_LIST = "@BILLING_AND_INVOICING/SET_INVOICE_LIST";
export const SET_BILL_LIST = "@BILLING_AND_INVOICING/SET_BILL_LIST";
export const SET_INVOICE_SETTINGS_LIST = "@BILLING_AND_INVOICING/SET_INVOICE_SETTINGS_LIST";
